import styled from "@emotion/styled";


export const Grid = styled.div`
    display: grid;
`

export const Flex = styled.div`
    display: flex;
`

export const Center = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Between = styled.div`
    display: flex;
    justify-content: space-between;
`

export const AlignCenter = styled.div`
    display: flex;
    align-items: center;
`
